import { FEATURE_ACCESS_RULES } from './accessRulesConfig';

export const isFeatureAllowed = (selectedAccount, accessRule) => {
    if (!selectedAccount || !accessRule) return false;

    return accessRule.some(checkFn => checkFn(selectedAccount));
};

export const isFeatureAllowedForICPAccount = (selectedAccount, accountConfig, featureFlag) => {
    if (accountConfig?.[featureFlag] === 'true') {
        return true;
    }

    const accessRule = FEATURE_ACCESS_RULES[featureFlag];

    return isFeatureAllowed(selectedAccount, accessRule);
};
